// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { loadResource } = require("path/middleware")
import { authConditional, composeMiddleware } from "lib/core/routing/middleware"

const onRouteToAchievement = function (nextState) {
  nextState.match.params.section =
    window.App.getStore("resource").getState().section
  return loadResource(nextState)
}

const getDefaultLaunchedFrom = ({ location }) =>
  location.pathname.split("achievement/").join("") + "about/"

export default {
  path: "/library/:resourceSlug/:cohortId(\\d+)?/achievement/",
  components: {
    primary: require("library/show/components/LibraryResourceContainer")
      .default,
    modal: require("./completion/PathCompletion").default
  },
  onEnter: composeMiddleware(authConditional, onRouteToAchievement),
  getDefaultLaunchedFrom
}
